import type { AuthErrorCode } from './auth-client';

export type AuthErrorI18nKey =
  | 'auth.invalidCredentials'
  | 'auth.emailNotConfirmed'
  | 'auth.emailVerificationExpired'
  | 'auth.sessionExpired'
  | 'auth.rateLimited'
  | 'auth.socialDisabled'
  | 'auth.emailTaken'
  | 'auth.signupFailed'
  | 'auth.accountUnavailable'
  | 'network.offline'
  | 'network.server'
  | 'validation.ageRestriction'
  | 'validation.custom';

const AUTH_ERROR_KEYS: Record<AuthErrorCode, AuthErrorI18nKey> = {
  invalid_credentials: 'auth.invalidCredentials',
  email_not_confirmed: 'auth.emailNotConfirmed',
  email_verification_expired: 'auth.emailVerificationExpired',
  session_expired: 'auth.sessionExpired',
  rate_limited: 'auth.rateLimited',
  social_disabled: 'auth.socialDisabled',
  network: 'network.offline',
  age_restriction: 'validation.ageRestriction',
  email_taken: 'auth.emailTaken',
  validation_error: 'validation.custom',
  signup_failed: 'auth.signupFailed',
  account_unavailable: 'auth.accountUnavailable',
  unknown: 'network.server',
};

export const authErrorKey = (code: AuthErrorCode): AuthErrorI18nKey => AUTH_ERROR_KEYS[code];

